<template lang="">
  <div>
    
    <div id="Sub63738967_1" class="ModuleContainer SubContainer ModuleGridItem     col-xs-12 col-sm-2 col-md-2 col-lg-2" positiontype="2" ismodulecontainer="true">
  
      <div class="ModuleItem  StaticModule  " wo="200" id="module_63738968">

          <div class="ModuleCommonClsGiant layout-103 layout-color-red module_63738968 clearfix">

              <!-- 主体 -->

              <div class="BodyCenter BodyCenter63738968 clearfix">

                  <ul class="one-classify  ">
                  
                      <li :class="{'main-class-item':true,active:$route.path==='/contact/maps'}" >

                          <router-link  to="/contact/maps"  class="OneRow main-class-text">联系我们</router-link>

                      </li>

                      <li :class="{'main-class-item':true,active:$route.path==='/contact/join'}" >

                          <router-link  to="/contact/join"  class="OneRow main-class-text">加入我们</router-link>

                      </li>

                  

                      <li :class="{'main-class-item':true,active:$route.path==='/contact/feedback'}" >

                          <router-link to="/contact/feedback"  class="OneRow main-class-text">意见反馈</router-link>

                      </li>

                  </ul>

              </div>

          </div>



      </div>

  </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
    }
  },
  created() {
    
  },
  methods: {
    
  },
}
</script>
<style lang="scss" scoped>
  #Sub63738967_1{
    
  }
</style>